import axios from 'axios'
const api = axios.create({
    baseURL: process.env.API_URL || 'https://clincal-triage-service.azurewebsites.net/api' // 'http://localhost:7071/api'   
})

export default api